<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 14H8.66667M1.66665 14.3334L5.36616 12.9105C5.60279 12.8195 5.7211 12.774 5.83179 12.7146C5.93012 12.6618 6.02385 12.6009 6.11201 12.5324C6.21126 12.4554 6.3009 12.3658 6.48017 12.1865L14 4.66671C14.7364 3.93033 14.7364 2.73642 14 2.00004C13.2636 1.26366 12.0697 1.26366 11.3333 2.00004L3.8135 9.51985C3.63423 9.69912 3.5446 9.78876 3.46758 9.88801C3.39916 9.97617 3.33825 10.0699 3.28547 10.1682C3.22605 10.2789 3.18055 10.3972 3.08954 10.6339L1.66665 14.3334ZM1.66665 14.3334L3.03873 10.766C3.13691 10.5107 3.18601 10.3831 3.27021 10.3246C3.3438 10.2735 3.43485 10.2542 3.52285 10.271C3.62354 10.2902 3.72024 10.3869 3.91364 10.5803L5.4197 12.0864C5.6131 12.2798 5.7098 12.3765 5.72903 12.4772C5.74583 12.5652 5.72651 12.6562 5.67541 12.7298C5.61695 12.814 5.48931 12.8631 5.23403 12.9613L1.66665 14.3334Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
